<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="0">
          <v-card-title class="font-weight-light text-h4">{{ $route.meta.tip }} Retrieval</v-card-title>
          <v-stepper vertical v-model="usernameStep" class="elevation-0">
            <v-stepper-step step="1" :complete="usernameStep > 1">Identify Yourself</v-stepper-step>
            <!-- Step 1 -->
            <v-stepper-content step="1">
              <v-form ref="indentifyForm" v-model="identityValid">
                <v-card tile elevation="0" :loading="loadingAcct">
                  <v-card-text class="pb-0">
                    <p class="text-h6">Please enter your email address</p>
                    <v-btn @click="altDialog = true" class="text-capitalize p-0" link text color="primary">I don't know my email</v-btn>
                    <div class="mt-10">
                      <v-text-field
                        type="email"
                        name="email"
                        :disabled="loadingAcct"
                        @blur="resetBlurValid"
                        prepend-inner-icon="mdi-email"
                        @keydown.enter.prevent="findAccount"
                        :rules="emailRules"
                        label="Email Address"
                        outlined
                        v-model="emailAddress"
                        required
                      ></v-text-field>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pt-1">
                    <v-row dense>
                      <v-col cols="12">
                        <template>
                          <vue-recaptcha
                            @verify="captAction(true)"
                            @expired="captAction(false)"
                            sitekey="6Le37CUTAAAAAIjclCmXF2YLjBSpk0d3wiO9Qp7y"
                            :loadRecaptchaScript="true"
                          ></vue-recaptcha>
                        </template>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          :loading="loadingAcct"
                          @click="findAccount"
                          :disabled="!identityValid || !captOk"
                          color="primary"
                          depressed
                          min-width="125px"
                          width="50%"
                        >
                          Find account
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-stepper-content>
            <v-stepper-step step="2" :complete="usernameStep > 2">Email Check</v-stepper-step>
            <!-- Step 2 -->
            <v-stepper-content step="2">
              <v-slide-y-transition mode="out-in">
                <template v-if="loadingEmails">
                  <v-progress-circular color="deep-purple accent-4" indeterminate></v-progress-circular>
                </template>
                <template v-if="!loadingEmails && emailList.length > 1">
                  <div>
                    <label class="font-weight-bold">Where should send your Username?</label>
                    <v-radio-group v-model="selectedEmail" class="px-3">
                      <v-radio
                        :class="{
                          'font-weight-bold': item.semail.toLowerCase() == emailAddress.toLowerCase(),
                        }"
                        v-for="item in emailList"
                        :key="item.email_type"
                        :label="item.semail.toLowerCase() != emailAddress.toLowerCase() ? replaceBetween(item.semail, '*') : item.semail"
                        :value="item.semail"
                      ></v-radio>
                    </v-radio-group>
                    <v-slide-y-transition>
                      <template v-if="selectedEmail.toLowerCase() != emailAddress.toLowerCase() && selectedEmail != ''">
                        <v-text-field
                          label="Confirm the Chosen Email"
                          type="email"
                          @keydown.enter="sendUsername(selectedEmail)"
                          prepend-inner-icon="mdi-email"
                          outlined
                          v-model="confirmEmail"
                        ></v-text-field>
                      </template>
                    </v-slide-y-transition>
                  </div>
                </template>
              </v-slide-y-transition>
              <v-slide-y-transition>
                <template v-if="emailList.length > 1 && !loadingEmails">
                  <v-card-actions>
                    <v-btn outlined color="primary" @click="passwordStep = 1" :disabled="loadingAcct">Back</v-btn>
                    <v-btn :disabled="dynEmail" depressed color="primary" :loading="loadingAcct" @click="sendUsername(selectedEmail)">Next</v-btn>
                  </v-card-actions>
                </template>
              </v-slide-y-transition>
            </v-stepper-content>
            <!-- Step 3 -->
            <v-stepper-step step="3" :complete="usernameStep > 3">Confirm</v-stepper-step>
            <template v-if="emailList != ''">
              <v-stepper-content step="3">
                <template v-if="usernameResult == 1">
                  <p>
                    Your Username has been sent to
                    <b>{{ chosenEmail }}</b>
                    . Please remember to check your "spam" or "junk" folder for this email. If you don't receive this email within 15 minutes,
                    <!-- {{ emailList[0].service_msg }} -->
                    <span v-html="emailList[0].service_msg"></span>
                    <a :href="'tel:' + emailList[0].service_phone">
                      {{ emailList[0].service_phone }}
                    </a>
                    .
                  </p>
                </template>
                <template v-else>
                  <div>
                    <p>
                      We're sorry, but it looks like the email address we have associated to your record has not yet been verified. We've resent you a
                      verification request so you can complete your email verification. Upon your completion of the Verification process, you will
                      receive your User Name.
                    </p>
                    <p>
                      If you do not receive an email within 30 minutes, please call
                      <a :href="'tel:' + emailList[0].service_phone">
                        {{ emailList[0].service_phone }}
                      </a>
                      {{ emailList[0].service_hours }}
                    </p>
                  </div>
                </template>
                <v-card-actions>
                  <v-btn outlined color="primary" :href="getHome">Back to Login</v-btn>
                  <v-btn depressed color="primary" to="/password">Get Password</v-btn>
                </v-card-actions>
              </v-stepper-content>
            </template>
          </v-stepper>
        </v-card>

        <!-- altIdentifyDialog -->
        <v-dialog v-model="altDialog" persistent max-width="600px">
          <altIdentifyDialog
            ref="altIdentification"
            :alt-dialog="altIdentify"
            @alt-dialog="handleAltDialog"
            @alt-success="altProcess"
            @alt-inputs="altinputsvalue"
          />
        </v-dialog>

        <!-- Verification Code not found -->
        <v-dialog v-model="codenotverified" persistent max-width="350">
          <v-card>
            <v-card-title class="headline pink--text accent-4">Code not found</v-card-title>
            <v-card-text>We were unable to verify your code.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                text
                @click="
                  codenotverified = false;
                  usernameStep = 1;
                "
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Username not found -->
        <v-dialog v-model="notFound" persistent max-width="350">
          <v-card>
            <v-card-title class="headline pink--text accent-4">Username not found</v-card-title>
            <v-card-text>
              We were unable to find any Username matching the email
              <b>{{ emailAddress }}</b>
              . Would you like to try again or find your Username using some other information?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-grey darken-3"
                text
                @click="
                  notFound = false;
                  altDialog = true;
                "
              >
                Try another way.
              </v-btn>
              <v-btn color="primary" text @click="notFound = false">Try Again</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Verified Email not Found -->
        <template v-if="emailList != ''">
          <v-dialog v-model="addNewEmail" persistent max-width="350">
            <v-window v-model="newEmailStep">
              <v-window-item :value="1">
                <v-card :loading="submittingNewEmail">
                  <v-card-title class="headline pink--text accent-4">Verified Email not Found</v-card-title>
                  <v-form ref="newEmailForm" v-model="validNewEmail">
                    <v-card-text>
                      We were unable to find a verified email for your account. To gain access to your account, you must enter and verify an email
                      address.
                      <v-divider class="my-4"></v-divider>
                      <v-text-field
                        type="email"
                        name="email"
                        :disabled="submittingNewEmail"
                        @blur="resetBlurValid"
                        prepend-inner-icon="mdi-email"
                        @keydown.enter.prevent="addPendedEmail"
                        :rules="emailRules"
                        label="Email Address *"
                        outlined
                        v-model="newEmail"
                        required
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue-grey darken-3"
                        text
                        @click="
                          addNewEmail = false;
                          newEmail = '';
                        "
                      >
                        Cancel
                      </v-btn>
                      <v-btn color="primary" text @click="addPendedEmail" :disabled="!validNewEmail" :loading="submittingNewEmail">Submit</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-window-item>
              <v-window-item :value="2">
                <v-card :loading="verifyingEmail">
                  <v-card-title class="headline font-weight-light">Almost there...</v-card-title>
                  <v-card-text>
                    We've sent an email to
                    <b>{{ newEmail }}</b>
                    that contains a 4 digit verification code. Keep this window open to enter the code below to complete the verification process.
                    <v-divider class="my-4"></v-divider>
                    <v-text-field
                      type="number"
                      inputmode="decimal"
                      maxlength="4"
                      label="Verification Code"
                      outlined
                      hint="This is a 4 digit code that you received to complete the Verification Process"
                      persistent-hint
                      @keydown.enter.prevent="verifyPendedEmail"
                      :disabled="verifyingEmail"
                      v-model="verificationCode"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="verifyPendedEmail" :loading="verifyingEmail" :disabled="verificationCode.length < 4">
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-window-item>
              <v-window-item :value="3">
                <v-card>
                  <v-card-title class="headline font-weight-light green--text">All Set!</v-card-title>
                  <v-card-text>
                    <p>
                      Thanks for taking the time to add and verify your email address! We've sent you your username to
                      <b>{{ newEmail }}</b>
                      . Remember to check your spam/junk folder if you don't see the email in your inbox within a few minutes
                    </p>
                    <!-- 04/30/2024 ACCTMG-5602- pass different message for account vise  --- -->
                    <!-- <p>
                      If you do not receive an email within 30 minutes, please call
                      <a href="tel:+1.800.945.5513">1.800.945.5513</a>
                      Monday - Friday 8:30 AM - 5:00 PM Eastern Time.
                    </p> -->
                    <p v-if="emailList.length > 0">
                      If you don't receive this email within 30 minutes,
                      <!-- {{ emailList[0].service_msg }} 06/03/2024 - pass dynamic message from database as html text-->
                      <span v-html="emailList[0].service_msg"></span>
                      <a :href="'tel:' + emailList[0].service_phone">{{ emailList[0].service_phone }}</a>
                      {{ emailList[0].service_hours }}.
                    </p>
                    <p v-else>
                      If you do not receive an email within 30 minutes, please call
                      <a href="tel:+1.800.945.5513">1.800.945.5513</a>
                      Monday - Friday 8:30 AM - 5:00 PM Eastern Time.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn to="/" text>More Help</v-btn>
                    <v-btn text color="primary" :href="getHome">Sign In</v-btn>
                  </v-card-actions>
                </v-card>
              </v-window-item>
            </v-window>
          </v-dialog>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import altIdentifyDialog from "@/components/altIdentify";
import axios from "axios";
import { mapGetters } from "vuex";
import VueRecaptcha from "vue-recaptcha";
export default {
  name: "username",
  components: {
    altIdentifyDialog,
    VueRecaptcha,
  },
  data: function () {
    return {
      altDialog: false,
      captOk: false,
      confirmEmail: "",
      usernameStep: 1,
      notFound: false,
      altIdentify: false,
      identityValid: true,
      validNewEmail: true,
      submittingNewEmail: false,
      newEmailStep: 1,
      loadingEmails: false,
      emailAddress: "",
      loadingAcct: false,
      emailList: [],
      chosenEmail: "",
      selectedEmail: "",
      addNewEmail: false,
      verifyingEmail: false,
      verificationCode: "",
      addedRID: "",
      newEmail: "",
      emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
      usernameResult: null,
      computedDateFormatted: "",
      ssnInput: "",
      zipInput: "",
      codenotverified: false,
    };
  },
  props: ["retrievalSelection", "dateFormatted", "ssnvalue", "zipvalue"],
  watch: {
    emailAddress: function () {
      if (this.emailAddress == "") {
        this.resetValidation();
      }
    },
  },
  computed: {
    ...mapGetters(["getHome"]),
    methodUrl() {
      return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1 ||
        location.href.toLowerCase().indexOf("me360dev") > -1
        ? ""
        : "http://localhost";
    },
    dynEmail() {
      var self = this;
      if (self.selectedEmail == "") {
        return true;
      } else if (self.selectedEmail.toLowerCase() == self.emailAddress.toLowerCase()) {
        return false;
      } else if (self.selectedEmail.toLowerCase() != self.emailAddress.toLowerCase()) {
        if (self.confirmEmail.toLowerCase() == self.selectedEmail.toLowerCase()) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  methods: {
    captAction(r) {
      var self = this;
      self.captOk = r;
    },
    replaceBetween(item, rpWith) {
      return item.substr(0, 1) + `${rpWith.repeat(item.substr(1, item.indexOf("@") - 1).length)}` + item.substr(item.indexOf("@"));
    },
    altProcess(value) {
      //console.log("altProcess " + value);
      var self = this;
      this.emailList = value;
      this.usernameStep = 2;
      this.loadingEmails = true;
      this.altIdentify = false;
      if (value == 2) {
        self.addNewEmail = true;
        self.newEmailStep = 1;
        self.newEmail = "";
        self.verificationCode = "";
        self.loadingAcct = false;
        self.loadingEmails = false;
        self.verifyingEmail = false;
      } else if (value == 0) {
        self.notFound = true;
        self.usernameStep = 1;
        self.loadingAcct = false;
        self.loadingEmails = false;
      } else {
        this.sendUsername(JSON.parse(value)[0].semail);
      }
    },
    handleRetrieveError(r) {
      this.$emit("retrieve-error", r);
      this.loadingAcct = false;
      this.loadingEmails = false;
    },
    handleAltDialog(value) {
      this.altDialog = value;
    },
    altIdentifyPop() {
      this.altIdentify = true;
    },
    resetForm() {
      this.$emit("reset-form");
      this.emailAddress = "";
      this.usernameStep = 1;
    },

    addPendedEmail() {
      var self = this;
      self.submittingNewEmail = true;
      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/AddEmailToPend", {
          u_dob: self.computedDateFormatted,
          u_ssn: self.ssnInput,
          u_zip: self.zipInput,
          new_email: self.newEmail,
        })
        .then(function (response) {
          if (response.data.d != "Failed") {
            self.submittingNewEmail = false;
            self.newEmailStep = 2;
            self.addedRID = response.data.d;
          }
        });
    },
    altinputsvalue(dat, ssn_, zip_) {
      this.computedDateFormatted = dat;
      this.ssnInput = ssn_;
      this.zipInput = zip_;
    },
    verifyPendedEmail() {
      var self = this;
      self.verifyingEmail = true;
      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/VerifyEmailSendUsername", {
          verify_rid: self.addedRID,
          auto_code: self.verificationCode,
        })
        .then(function (response) {
          if (response.data.d == "Sucess") {
            self.newEmailStep = 3;
            self.codenotverified = false;
          } else {
            //alert("Error");
            //self.newEmailStep = 1;
            self.verifyingEmail = false;
            self.addNewEmail = false;
            self.codenotverified = true;
          }
        });
    },
    findAccount() {
      var self = this;

      if (self.identityValid) {
        this.loadingAcct = true;
        self.loadingEmails = true;
        axios
          .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/get_user_email", {
            user_email: self.emailAddress,
          })
          .then(function (response) {
            if (response.data.d == "NO Found") {
              self.loadingAcct = false;
              self.notFound = true;
            } else {
              self.emailList = JSON.parse(response.data.d);
              if (self.emailList.length >= 2) {
                self.loadingEmails = false;
                self.usernameStep = 2;
                self.loadingAcct = false;
              } else {
                self.sendUsername(self.emailList[0].semail);
              }
            }
          })
          .catch(function () {
            self.notFound = true;
            self.loadingAcct = false;
            self.loadingEmails = false;
          });
      }
    },
    sendUsername(r) {
      var self = this;
      self.chosenEmail = r;
      self.loadingAcct = true;
      axios
        .post(self.methodUrl + "/web_projects/UsernamePassword/WebMethods.aspx/SendUserName", {
          user_email: r,
        })
        .then(function (response) {
          if (response.data.d == "Email Not Verified") {
            self.usernameResult = 2;
            self.usernameStep = 3;
            self.loadingAcct = false;
          } else if (response.data.d == "Sucess") {
            self.usernameResult = 1;
            self.usernameStep = 3;
            self.loadingAcct = false;
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("there was an error sending the email.");
          }
        });
    },
    validate() {
      this.$refs.indentifyForm.validate();
    },
    resetValidation() {
      this.$refs.indentifyForm.resetValidation();
    },
    resetBlurValid() {
      if (this.emailAddress == "") {
        this.$refs.indentifyForm.resetValidation();
      }
    },
  },
};
</script>
